export default {
  product_info: 'Informacje o produkcie',
  return: 'Wróć do opcji',
};
